
<template>
      <div class="order-main">
          <left-menu></left-menu>
          <div class="flexGrow"><router-view></router-view></div></div>
</template>

<script>
import {defineAsyncComponent} from 'vue';
const LeftMenu = defineAsyncComponent(() => import('./leftMenu'))
export default {
    components: { LeftMenu }
}
</script>

<style lang="less" scoped>
.order-main{     display: flex;     position: relative;      :deep(.flexGrow ){         width: calc(100% - 240px);     } }
</style>
